module.exports = __webpack_public_path__ + "static/img/u37.776b7dda.png";